// extracted by mini-css-extract-plugin
export default {"actionBtn":"Mycustombutton_actionBtn__YCu6i"};